module.exports = __webpack_public_path__ + "static/media/wdv.88b8a94c.webp";